import { useState } from "react";
import { ChessPuzzle } from "@react-chess-tools/react-chess-puzzle";
import { AdBanner } from "../adBanner/AdBanner";
import { PUZZLES } from "../../data/puzzles";
import "./PuzzlePage.css";

export function PuzzlePage() {
    const [index, setIndex] = useState(0);

    const current = PUZZLES[index];

    const goToPuzzle = (newIndex) => {
        setIndex(newIndex);
    };

    const prevPuzzle = () => {
        if (index === 0) {
            goToPuzzle(PUZZLES.length - 1);
        } else goToPuzzle(index - 1);
    };

    const nextPuzzle = () => {
        if (index === PUZZLES.length - 1) {
            goToPuzzle(0);
        } else goToPuzzle(index + 1);
    };

    const randomPuzzle = () => {
        if (PUZZLES.length <= 1) {
            return;
        }

        let newIndex = index;

        while (newIndex === index) {
            newIndex = Math.floor(Math.random() * PUZZLES.length);
        }

        setIndex(newIndex);
    };

    return (
        <div className="app-container">
            <div className="chess-wrapper">
                <div className="puzzle-info">
                    <h2>
                        Задача {index + 1} из {PUZZLES.length}: {current.title}
                    </h2>
                    <p className="puzzle-info-description">{current.description}</p>
                </div>

                <ChessPuzzle.Root key={current.id} puzzle={current.puzzle}>
                    <div className="board-container">
                        <ChessPuzzle.Board />
                    </div>

                    <div className="controls-container">
                        <ChessPuzzle.Reset className="btn btn-reset">
                            Заново
                        </ChessPuzzle.Reset>

                        <ChessPuzzle.Hint className="btn btn-hint">
                            Подсказка
                        </ChessPuzzle.Hint>
                    </div>
                </ChessPuzzle.Root>

                <div className="controls-container puzzle-navigation">
                    <button
                        type="button"
                        className="btn"
                        onClick={prevPuzzle}
                    >
                        ←
                    </button>

                    <button
                        type="button"
                        className="btn"
                        onClick={randomPuzzle}
                    >
                        Случайная
                    </button>

                    <button
                        type="button"
                        className="btn"
                        onClick={nextPuzzle}
                    >
                         →
                    </button>

                </div>

                <AdBanner />
            </div>
        </div>
    );
}
